export default "__VITE_ASSET__jDy2G2aD__"